'use client';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { ProductRating } from '../detail/product-rating';
import { Heading } from '../../ui/heading';

export function ProductTabsReviews() {
  const product = useVariantsStore(state => state.product);
  const rating = product.rating ?? 0;
  const reviewCount = product.ratingCount ?? 0;

  return (
    <div className="flex w-full flex-col items-center justify-center gap-6 sm:gap-8">
      <div className="flex w-full flex-col items-center justify-center gap-2">
        <Heading title={`Hodnotenie produktu (${reviewCount})`} tag="h2" styleAs="h4" center />
        <ProductRating rating={rating} ratingCount={reviewCount} />
      </div>
    </div>
  );
}
